export default "__VITE_ASSET__DOQMQ5OO__"